export const getAmount = () => parseInt(process.env.VUE_APP_REFER_A_FRIEND_PROMOTION);

export const isAvailable = () => {
  if (
    !process.env.VUE_APP_REFER_A_FRIEND_PROMOTION ||
    isNaN(Date.parse(process.env.VUE_APP_REFER_A_FRIEND_PROMOTION_START)) ||
    isNaN(Date.parse(process.env.VUE_APP_REFER_A_FRIEND_PROMOTION_END))
  ) {
    return false;
  }
  try {
    const now = new Date();
    const amount = parseInt(process.env.VUE_APP_REFER_A_FRIEND_PROMOTION);
    const start = new Date(process.env.VUE_APP_REFER_A_FRIEND_PROMOTION_START);
    const end = new Date(process.env.VUE_APP_REFER_A_FRIEND_PROMOTION_END);
    end.setDate(end.getDate() + 1);

    return amount && start <= now && end > now;
  } catch (e) {
    return false;
  }
};
